import styled, { keyframes, css } from 'styled-components';
import { useTranslation } from '../../hooks/useNavConfig';
import { jsx as _jsx } from "react/jsx-runtime";
const spin = keyframes(["0%{transform:rotate(0deg);}100%{transform:rotate(360deg);}"]);
const StyledSpinner = styled.div.withConfig({
  displayName: "LoadingSpinner__StyledSpinner",
  componentId: "sc-8r6dvt-0"
})(({
  width = '24px',
  height = '24px',
  theme: _theme
}) => {
  const theme = _theme;
  return css(["width:", " !important;height:", " !important;border:3px solid ", " !important;border-top:3px solid ", " !important;border-radius:50% !important;animation:", " 1s linear infinite !important;"], width, height, theme.color['fill-info-hover'], theme.color['fill-info-default'], spin);
});
export const LoadingSpinner = ({
  width,
  height
}) => {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/_jsx(StyledSpinner, {
    width: width,
    height: height,
    role: "status",
    "aria-label": t('nav.ui.components.loading.ariaLabel')
  });
};